import * as React from "react"
import {mergeDicts} from "@ui-seeker/utils";

import {actionsColumn, associatedSkuColumn, priceColumn, productRawColumn, retailerInfoColumn, scoringColumn, associatedIASkuColumn, validatedColumn} from "./columns";
import { AppTableSeeker } from "@components"


export default function AdminProductReviewBaseTable({ id, data=[], title='', subtitle='', hideActions=false, isSkuMappingTable=false, ...props }) {
    return <AppTableSeeker
		title={title}
		subtitle={subtitle}
		data={data}
		columns={[
			...retailerInfoColumn(),
			...productRawColumn(hideActions),
			...associatedSkuColumn(),
			...associatedIASkuColumn(),
			scoringColumn(),
			priceColumn(),
			...validatedColumn(),
			// ...( hideActions ? [] : [actionsColumn(isSkuMappingTable)])  // DISABLED TEMPORARILY
		]}
		{...props}
		options={{
			print: false,
			...props?.options,
			enhancedSetRowProps: () => mergeDicts({ sx: {
				"&:has(.is-open)": {backgroundColor: "warning.light"},
			}}, props?.options?.enhancedSetRowProps && props?.options?.enhancedSetRowProps())
		}}
	/>
}